<script lang="ts" setup>
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'
import PickUpPointNotification from '~/components/modal-windows/shipping/PickUpPointNotification.vue'
import constants from '~/constants'
import helpers from '~/helpers'
import { useCartStore } from '~/store/cart'

const model = defineModel<boolean>()

const props = defineProps<{
  declaredValueInRubles: number
  weightInGrams: number
}>()

const cartStore = useCartStore()

const scriptElement = ref<HTMLScriptElement | null>(null)

function close (): void {
  model.value = false
}

function closed (): void {
  (scriptElement.value as HTMLScriptElement).parentNode?.removeChild(scriptElement.value as HTMLScriptElement)
}

function opened (): void {
  const { declaredValueInRubles, weightInGrams } = props

  const elementId = 'boxberry_map'
  const element = document.getElementById(elementId)

  if (element) {
    element.innerHTML = ''
  }

  const _scriptElement = document.createElement('script')
  _scriptElement.async = true
  _scriptElement.onload = (): void => {
    const boxberry = (window as any).boxberry
    boxberry.openOnPage(elementId)
    boxberry.open(
      (result: any): void => {
        console.log(result)

        const { address, id, name, phone, period, price, workschedule } = result

        cartStore.shippingCostInKopecks = helpers.convertRublesToKopecks(Number(price))
        cartStore.shippingData = {
          address,
          code: id,
          name,
          phone,
          shippingPeriodInDays: period,
          workSchedule: workschedule
        }

        close()
      }, // Callback function.
      constants.boxberryIntegrationKey, // Integration key.
      undefined, // City.
      '', // Target.
      declaredValueInRubles, // Declared value in rubles.
      weightInGrams // Weight in grams.
    )
  }
  _scriptElement.src = 'https://points.boxberry.ru/js/boxberry.js'
  scriptElement.value = _scriptElement
  document.getElementsByTagName('head')[0].appendChild(_scriptElement)
}
</script>

<template>
  <CustomModalWindow v-model="model" size="large" @closed="closed" @opened="opened">
    <template #title>
      Выбор пункта выдачи заказов&nbsp;— Boxberry
    </template>

    <Notification class="mb-6" is-small status="info">
      Пожалуйста, дождитесь появления карты.
    </Notification>

    <PickUpPointNotification class="mb-6" />

    <div class="boxberry-map-area mb-6">
      <div id="boxberry_map" class="bg-white" />
    </div>

    <template #action>
      <a href="#" @click.prevent="close">Закрыть</a>
    </template>
  </CustomModalWindow>
</template>

<style lang="scss" scoped>
.boxberry-map-area {
  background: #f2f2f3;
  height: 560px;
}
</style>
